import { createFileRoute } from "@tanstack/react-router";
import { communitiesQuery } from "@/api/queries/communities";
import type { CategorySlug } from "@/api/types";
import { CommunitiesPage, CommunitiesPageSkeleton } from "@/pages/communities/CommunitiesPage";

interface CommunitiesSearch {
  q?: string;
  category?: CategorySlug;
}

export const Route = createFileRoute("/_app/communities")({
  validateSearch: (search): CommunitiesSearch => ({
    q: typeof search.q === "string" ? search.q : undefined,
    category:
      typeof search.category === "string" ? (search.category as CategorySlug) : undefined,
  }),
  loader: ({ context }) => context.queryClient.ensureQueryData(communitiesQuery({})),
  pendingComponent: CommunitiesPageSkeleton,
  component: CommunitiesPage,
});
